// extracted by mini-css-extract-plugin
module.exports = {"Education":"Education_Education__34gsb","anim":"Education_anim__33Cn9","Timeline":"Education_Timeline__Appze"};